// extracted by mini-css-extract-plugin
export default {"dialog":"TransactionNoteDialog_dialog__f0822"};